<template>
  <div class="page">
    <div class="mask"></div>
    <div class="popup">
      <div class="popup-bg">
        <img
          :src="require('@/assets/images/YuliApp/weeklyTask/pop_bg@2x.png')"
        />
      </div>
      <!-- name == Better luck next time 则是未抽中 -->
      <div class="popup-bgtitle">{{ name == 'Better luck next time' ? 'What a pity' : 'Claim Rewards' }}</div>
      <div class="popup-arg">
        <div class="popup-arg-title">{{ name == 'Better luck next time' ? '' : 'Congratulations' }}</div>
        <img
          v-if="img"
          :src="img"
        />
        <div class="popup-arg-name">{{name}}</div>
      </div>

      <!-- 弹窗按钮 -->
      <div class="popup-button" @click="handleClose">
        <!-- <img src="@/assets/images/YuliApp/weeklyTask/popup_close.png" /> -->
        <div class="popup-button-icon">
          <img class="popup-button-icon-left" src="@/assets/images/YuliApp/weeklyTask/close_arrow_icon.svg">
          <span class="popup-button-icon-text">Click to close</span>
          <img class="popup-button-icon-right" src="@/assets/images/YuliApp/weeklyTask/close_arrow_icon.svg">
        </div>
      </div>

    </div>
  </div>
</template>
<script>
// import { PRIZE_TYPE } from "../../constants/storagePrize";
import audioManager from "@/utils/audioManager";
export default {
  props: {
    name: {
      type: String,
      default: "",
    },
    img: {
      type: String,
      default: "",
    },
    id: {
      type: Number,
      default: -1,
    }
  },
  setup(props, ctx) {
    /**
     * 处理关闭
     */
    const handleClose = () => {
      audioManager.playCurBGM();
      ctx.emit("close", false);
    };
    return {
      handleClose,
    };
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
  }
  .popup {
    position: absolute;
    z-index: 9999;
    width: 100%;
    height: 264px;
    top: 20%;
    text-align: center;
    &-bg {
      width: 100%;
      height: 375px;
      animation: bgfade 0.3s ease-in-out both;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &-bgtitle {
      position: absolute;
      top: 26px;
      left: 50%;
      transform: translate(-50%, 0);
      color: rgba(255, 255, 255, 1);
      font-size: 30px;
      font-weight: 700;
      font-family: "Josefin Sans SemiBold";
      text-align: center;
      letter-spacing: -2.1px;
      text-shadow: rgba(230, 202, 59, 0.83) 4.57px 4.57px 4.57px;

      text-stroke: 1px rgba(255, 172, 75, 1);
      /* 兼容Webkit(Chrome/Safari)内核浏览器的写法 */
      -webkit-text-stroke: 1px rgba(255, 172, 75, 0.3);
      white-space: nowrap;
    }

    &-arg {
      position: absolute;
      top: 110px;
      left: 50%;
      transform: translate(-50%, 0);
      text-align: center;
      &-title {
        height: 25px;
        opacity: 1;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        font-weight: 700;
        font-family: "PingFang SC";
        text-align: center;
      }
      img {
        // width: 100px;
        max-height: 160px;
      }
      &-name {
        height: 23px;
        opacity: 1;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        font-weight: 500;
        font-family: "PingFang SC";
        text-align: center;
        line-height: 22px;
      }
    }
    &-button {
      position: relative;
      z-index: 999;
      margin: 0 auto;
      margin-top: 50px;
      width: 100%;
      display: flex;
      justify-content: center;
      // height: 42px;
      img {
        width: 100%;
        height: 100%;
      }
      &-icon{
        width: 125px;
        height: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        &-text{
          width: 83px;
          height: 16px;
          color: #bcc2c7;
          font-size: 13px;
          font-weight: 400;
          font-family: "PingFang SC";
          text-align: center;
          line-height: 15.6px;
        }
        img{
          width: 13px;
          height: 5.91px;
        }
        &-left{
          transform: rotateY(360deg);
        }
        &-right{
          transform: rotateY(180deg);
        }
      }
    }
  }
}
</style>
